// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"728":"d2ce83f9","787":"523f372d","909":"f3e4ba0f","922":"4a7ce985"}[chunkId] + ".chunk.js";
};